<template>
  <div class="indexVideo_img_icon_context">
    <div>
      <img
        class="indexVideo_img_icon"
        src="../../../../public/static/image/img-index-logo.png"
      />
    </div>
    <div class="indexVideo_img_btn">
      <div class="indexVideo_img_btn">
        <div class="indexVideo_img_btn_line btn_down">
          <router-link to="/download">
            <Button type="primary" shape="circle" size="large">
              免费下载</Button
            >
          </router-link>
        </div>
        <div class="indexVideo_img_btn_line_icons btn_down">
          <Button
            type="primary"
            ghost
            shape="circle"
            size="large"
            @click="clickBtn01"
          >
            查看演示
            <Icon
              type="ios-play-outline"
              class="indexVideo_img_btn_line_icon"
            />
          </Button>
        </div>
        <div class="indexVideo_img_btn_line_icons btn_down">
          <Button
            type="primary"
            ghost
            shape="circle"
            size="large"
            @click="clickBtn02"
          >
            产品介绍
            <Icon
              type="ios-play-outline"
              class="indexVideo_img_btn_line_icon"
            />
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    clickBtn01: {
      type: Function,
      default: function() {}
    },
    clickBtn02: {
      type: Function,
      default: function() {}
    }
  }
};
</script>
<style></style>
<style lang="less" scoped>
.indexVideo_img_icon_context {
  position: absolute;
  text-align: center;
  width: 100%;
  padding: 6%;
}
.indexVideo_img_icon {
  width: 50%;
  font-weight: bold;
}

.indexVideo_img_btn {
  display: flex;
  justify-content: space-around;
  padding-top: 2%;
  .indexVideo_img_btn_line_icons {
    padding: 10px 20px;
    font-size: 20px;
    .img_btn_line_icon {
      float: right;
    }
  }
  .indexVideo_img_btn_line {
    padding: 10px 20px;
  }
  .indexVideo_img_btn_line .ivu-btn {
    min-width: 120px !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 0 10px !important;
  }
  .indexVideo_img_btn_line_icons .ivu-btn {
    min-width: 120px !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding-left: 30px !important;
    font-weight: bold !important;
    border: 2px solid #2d8cf0 !important;
  }
  .indexVideo_img_btn_line_icons .ivu-btn:hover {
    background: #2d8cf0 !important;
    color: #ffff !important;
    font-weight: initial !important;
  }
}
</style>
